<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>선박소개</h3>
                        </div>
                        <div class="mt-5 border-top">
                            <div class="row card-header-bus">
                                <img src="img/theme/main1.png" style="width: 100%;">
                                <div style="background-color: #000000e3; width: 100%; padding: 30px; text-align: left;">
                                    <div class="font-20">태안 현아호</div>
                                    <div class="font-15">수용인원 : 17인승</div>
                                    <div class="font-15">위치 : 충남 태안군 근흥면 신진도리 542 안흥외항선착장</div>
                                    <div class="font-15">장비 : 최신 해양프로타, 레이더, 어탐 및 VHF 무전기, 각종 법정장비</div>
                                    <div class="font-15">편의시설 : 방송장비, 오디오시스템, 정수기, 화장실 </div>
                                    <div class="font-15">안전장비 : 승선 정원의 120퍼센트에 해당하는 구명조끼, 구명부환, 소화기, 구명밧줄, 자기발연, 자기발화, 엔진자동 소화기 완전구비함. </div>
                                    <div class="font-15">보험 : (유어선 관리법에 의해) 낚시객 승선정원 전원 보험가입 </div>                                    
                                </div>
                            </div>
                            <div style="text-align: center;">
                                <h3>어초,침선 전문 출조선 태안현아호는</h3>
                                <br>낚시를 즐기는 분들에게 최고의 경험을 제공하기 위해 항상 노력하고 있습니다. 
                                <br>외연도와 격비도 등 다양한 낚시 포인트를 찾아, 
                                <br>조황이 좋은 곳에서 만족스러운 낚시를 위해 최선을 다하고 있습니다. 
                                <br>언제나 기름을 아끼지 않고, 최적의 낚시 환경을 제공하기 위해 힘쓰고 있습니다.

                                <br>
                                <br>출조점 : 충남 태안군 근흥면 신진도리 542 안흥외항선착장
                                <br>출항지 : 시즌마다 선착장이 다릅니다. 오시기 전에 전화 후 확인해주세요.
                                <br>
                                <br>출조점에 04:00 까지 도착하여
                                <br>승선명부 작성 후 공정한 자리 추첨
                            </div>
                            <br>
                            <div style="border-bottom: 1px solid #e9ecef;"></div>
                            <div class="text-center mt-5" style="margin-bottom: 20px;">
                                <h3 style="font-weight: 300;">내부시설</h3>
                            </div>
                            <div style="border-bottom: 1px solid #e9ecef;"></div>
                            <br>
                            <div class="row justify-content-center">
                                <div class="row col-lg-12 p-0" style="display: flex;">
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/indoor1.png" width="100%" style="min-height: 250px;">
                                    </div>
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/indoor2.png" width="100%" style="min-height: 250px;">
                                    </div>
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/indoor3.png" width="100%" style="min-height: 250px;">
                                    </div>                                    
                                </div>
                                <div class="row col-lg-12 p-0" style="display: flex;">
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/indoor4.png" width="100%" style="min-height: 250px;">
                                    </div>
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/indoor5.png" width="100%" style="min-height: 250px;">
                                    </div>
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/indoor6.png" width="100%" style="min-height: 250px;">
                                    </div>                                    
                                </div>
                            </div>
                            <div style="border-bottom: 1px solid #e9ecef;"></div>
                            <div class="text-center mt-5" style="margin-bottom: 20px;">
                                <h3 style="font-weight: 300;">전하는 말씀</h3>
                            </div>
                            <div style="border-bottom: 1px solid #e9ecef;"></div>
                            <div>
                                <br>태안현아호는 출조점에 04:00까지 도착하여 승선명부 작성 후 
                                <br>자리는 추첨을 통해 공정하게 정해집니다.
                                <br>
                                <br><span><h5 style="color: red;" class="m-0">※ 신분증은 꼭 준비해 주세요. </h5></span>
                                ( 미지참시 선박 승선이 불가합니다.)
                                <br>
                                <br><span><h5 style="color: red;" class="m-0">※ 기상상황에 따라 부득이 일정이 취소될 가능성이 있는부분 미리 양해말씀 드립니다.  </h5></span>
                                (기상악화로 인한 출항 취소시 전액환불 및 날짜 변경을 진행해 드립니다.) 
                            </div>
                            <div class="line"></div>
                            <a href="/location">
                                <div class="btn btn-success">오시는 길</div>
                            </a>
                            <div class="line"></div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.line {
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 40px;
    margin-bottom:  40px;
}

.mid-line{
    border-bottom: 3px solid black;
    width: 40px;
    border-radius: 1em;
    margin-bottom: 30px;
}

.header-text{
    font-size: 25px;
    font-weight: 300;
    padding-bottom: 10px;
}

.card-div{
    padding: 0px 30px 0px 30px;
}

.card-header-bus{
    color:#FFF; 
    font-weight: 300;
    padding: 60px 0 60px 0;
    display: flex;
    justify-content: center;
    background-color: #FFF;
}

.bg-white-gray{
    background-color: #f3f3f3;
}

.ul{
    display: block;
}
.ul > li{
    display: inline-block;
    position: relative;
    font-size: 15px;
    color: #666;
    padding-left: 10px;
    display: inline-block;
    width: 300px;
    vertical-align: top;
    margin: 10px 0;
}

.font-20{
    font-size: 20px;
}
.font-15{
    font-size: 15px;
}
</style>
